
import React, {useEffect, useState} from 'react';
import { useMsal } from '@azure/msal-react';
import ApiProvider from '../../../apiProvider';
import Names from './names';
import Address from './address';
import ContactInfo from './contactInfo';
import Spinner from '../../skills-experience/shared/spinner';

const PersonalInfo = ({setMenuOptions}) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [loading, setLoading] = useState(true);
    const [personalInfo, setPersonalInfo] = useState({});

    // set menu for navigation updates
    useEffect(()=>{
        setMenuOptions("/Profile/info");
    },[])

    useEffect(()=> {
        loadPersonalInfo();
    }, []);

    async function loadPersonalInfo() {
        setLoading(true);
        await apiProvider.Get("Profile/GetPersonalInfo")
            .then(result => setPersonalInfo(result)).catch(err => console.err(err));
        
        setLoading(false);
    }

    return(
<>
{
    loading ? 
    <Spinner show={loading} />
    :
    <>
        <Names data={personalInfo.namesInfo} apiProvider={apiProvider} />
        <br/>
        <Address data={personalInfo.addressInfo} apiProvider={apiProvider} />
        <br/>
        <ContactInfo data={personalInfo.contactInfo} apiProvider={apiProvider} />
    </>
    }
</>
    )
};

export default PersonalInfo;